import { render } from "./CreateSugarModal.vue?vue&type=template&id=68f8749b&scoped=true&ts=true"
import script from "./CreateSugarModal.vue?vue&type=script&lang=ts"
export * from "./CreateSugarModal.vue?vue&type=script&lang=ts"

import "./CreateSugarModal.vue?vue&type=style&index=0&id=68f8749b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68f8749b"]])

export default __exports__